import { Exclude, Expose, Transform } from 'class-transformer';

export class TableParams {

    @Expose({ name: 'res' })
    Rows: number;

    @Expose({ name: 'sort' })
    @Transform(({ value, obj }) => {
        return (obj.SortDirection && obj.SortDirection === -1) ? value + '_desc' : value
    }, { toPlainOnly: true })
    SortBy: string;

    @Exclude()
    SortDirection: any;
}
